import { connect } from 'react-redux';
import { compose, withHandlers, withProps, withState } from 'recompact';

import { withClient } from 'src/app/hocs';
import { fetchCatchedMedicationsByName, searchForMedications } from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';

import { ApiAutoComplete } from '../container';

/**
 * This is used to generate a consistent `extrasFieldName` prop
 * for <DrugSearchAutoComplete> to save an "extras" formik value.
 */
export function getExtrasField(index: number) {
  return { extrasFieldName: `extras.${index}` };
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  searchForMedicationsByValues: values => dispatch(searchForMedications(values)),
  fetchCatchedMedicationsByName: name => dispatch(fetchCatchedMedicationsByName(name)),
});

export const DrugSearchAutoComplete = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('lastMedicationNameInput', 'setLastMedicationNameInput', null),
  withClient,
  withProps({
    noMatchingItemsText: 'No results. Please check spelling.',
    dataCyText: 'medicationItem',
  }),
  withHandlers({
    apiCall:
      ({ searchForMedicationsByValues, lastMedicationNameInput, fetchCatchedMedicationsByName }) =>
      async searchQuery => {
        const medicationResponseFromStore = await fetchCatchedMedicationsByName(searchQuery);

        if (medicationResponseFromStore) {
          //Cache Hit
          return medicationResponseFromStore.items?.medications;
        } else {
          const medicationsResponseFromAPI = await searchForMedicationsByValues(searchQuery);
          // Race condition if the first request comes after the second request
          if (medicationsResponseFromAPI.medicationName !== lastMedicationNameInput) {
            return [];
          }
          return medicationsResponseFromAPI.items.medications;
        }
      },
    selectedItemToString: () => item => item?.primaryName ?? '',
    optionItemToString: () => item => item?.primaryName ?? '',
    callbackToDrugSearch:
      ({ setLastMedicationNameInput }) =>
      async searchQuery => {
        setLastMedicationNameInput(searchQuery);
      },
  })
)(ApiAutoComplete);
